import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppPaymentMethodsApi } from './app'
import { BackofficePaymentMethodsApi } from './backoffice'
import { Queue } from '../../queue'

export class Payments implements ApiNamespaces {
  app: AppPaymentMethodsApi
  backoffice: BackofficePaymentMethodsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppPaymentMethodsApi(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficePaymentMethodsApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
